// Single shim resolved by the Vite alias for `'jquery'`. Written as CommonJS
// so that both `import $ from 'jquery'` (ESM, gets module.exports as default)
// and `require('jquery')` (UMD libraries like pc-bootstrap4-datetimepicker)
// receive the same value: the jQuery instance that the layout's
// <script src=".../jquery.min.js"> tag attached to window.
if (typeof window === 'undefined' || !window.jQuery) {
    throw new Error(
        'jQuery is missing on window. Ensure <script src="{{ asset(\'js/jquery.min.js\') }}"></script> ' +
        'is included in the layout <head> before @vite(...).'
    );
}
module.exports = window.jQuery;
module.exports.jQuery = window.jQuery;
module.exports.trim = window.jQuery.trim || function (s) {
    return String(s == null ? '' : s).replace(/^\s+|\s+$/g, '');
};
